import type { DisciplineProgressReportsStore } from './interfaces'

import { emptyDisciplineProgressReportsFilters } from '@helpers/discipline-progress-reports-query'

export const actions = {
  setLoading (this: DisciplineProgressReportsStore, payload: DisciplineProgressReportsStore['loading']): void {
    this.loading = payload
  },
  setReports (this: DisciplineProgressReportsStore, payload: DisciplineProgressReportsStore['reports']): void {
    this.reports = payload
  },
  setMeta (this: DisciplineProgressReportsStore, payload: DisciplineProgressReportsStore['meta']): void {
    this.meta = payload
  },
  setFilters (this: DisciplineProgressReportsStore, payload: DisciplineProgressReportsStore['filters']): void {
    this.filters = payload
  },
  patchFilters (this: DisciplineProgressReportsStore, payload: Partial<DisciplineProgressReportsStore['filters']>): void {
    this.filters = { ...this.filters, ...payload }
  },
  resetFilters (this: DisciplineProgressReportsStore): void {
    this.filters = emptyDisciplineProgressReportsFilters()
    this.currentPage = 1
  },
  setCurrentPage (this: DisciplineProgressReportsStore, payload: DisciplineProgressReportsStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: DisciplineProgressReportsStore, payload: DisciplineProgressReportsStore['perPage']): void {
    this.perPage = payload
  },
  setEditingReport (this: DisciplineProgressReportsStore, payload: DisciplineProgressReportsStore['editingReport']): void {
    this.editingReport = payload
  },
  /** The list answer goes with the page it was read for: the next visit starts empty, under its loader, never
   *  showing stale rows until its own land. Filters and paging stay. */
  resetList (this: DisciplineProgressReportsStore): void {
    this.reports = []
    this.meta = null
  },
}
